import { EColors } from 'common/styles'
import styled from 'styled-components'

export const Container = styled.section`
  width: 100%;
  background-color: ${EColors.bg_light};
  position: relative;
  overflow: hidden;
  padding-top:140px;
  padding-bottom: 140px;
  @media screen and (max-width: 1000px) {
    padding-top:60px;
    padding-bottom: 60px;
  }
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 140px;

  @media screen and (max-width: 767px) {
    gap: 60px;
  }
`
